import { LeadService } from '@forwardflow/services/LeadService'
import { useOrgSWR } from '@forwardflow/hooks'
import { QUERY_KEYS } from '@forwardflow/helpers/utils'

export const useContactDetails = (leadId: number | null) => {
   return useOrgSWR(
      leadId ? [QUERY_KEYS.LEAD_DETAILS, leadId] : null,
      async () => {
         if (!leadId) return null
         const response = await LeadService.getLeadById(leadId)
         if (!response) {
            throw new Error('Lead not found')
         }
         return response
      },
      {
         revalidateOnFocus: false,
         shouldRetryOnError: false,
      }
   )
}
